import TaTransactionOrderCardTraveler from './TaTransactionOrderCardTraveler'

export default TaTransactionOrderCardTraveler
